const fetchAlert = state => state.alert;
const fetchLoading = state => state.loading;
const isMobileScreen = state => state.isMobileScreen;
const socketError = state => state.socketError;
const loadingMessage = state => state.loadingMessage;

export default {
  fetchAlert,
  fetchLoading,
  isMobileScreen,
  socketError,
  loadingMessage
};
